import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import useScreenHeight from '../../../components/useScreenHeight';
import { GetUserList } from '../../../actions/UserActions';


const UsersSidebar = () => {

    const dispatch = useDispatch();
    const userListInfo = useSelector(state => state.userListInfo.value);
    const screenHeight = useScreenHeight();
    const [userList, updateUserList] = useState([]);
    const [searchText, updateSearchText] = useState('');
    const [filteredUserList, updateFilteredUserList] = useState([]);
    const [showInactive, updateShowInactive] = useState(false);
    const [licenseLevel, updateLicenseLevel] = useState(0);
    const [usersToShow, updateUsersToShow] = useState('TrinDocs');

    useEffect(() => {
      console.log('effect');
      console.log(userListInfo);
        if (userListInfo.userList.length === 0){
          GetUserList(dispatch);
        }
        else {
          let filterList = sortUsers(userListInfo.userList, usersToShow);
          updateUserList(userListInfo.userList);

          updateFilteredUserList(filterList);
        }

      }, [userListInfo]);


  const onSearchChange = (e) => {
    let search = e.target.value;
    if (search === '') {
      let newList = [...userList];
      updateSearchText(search);
      updateFilteredUserList(newList);
    } else {
      let newList = [];
      userList.forEach((user) => {
        if (
          user.userName.toLowerCase().includes(search.toLowerCase()) ||
          user.firstName.toLowerCase().includes(search.toLowerCase()) ||
          user.lastName.toLowerCase().includes(search.toLowerCase())
        ) {
          newList.push(user);
        }
      });
      updateSearchText(search);
      updateFilteredUserList(newList);

    }
  }

  const changeShowInactive = (e) => {
    let showInactive = e.target.checked;
    updateShowInactive(showInactive);
  }

  const sortUsers = (list, filterType) =>
  {
    let filter = [...list];
    if(filterType === 'TrinForms')
    {
      filter.sort((a, b) => {
        if(a.trinFormsLicenseLevel > b.trinFormsLicenseLevel)
        {
          return -1;
        }
        else if(a.trinFormsLicenseLevel < b.trinFormsLicenseLevel)
        {
          return 1;
        } else {
          if (a.userName.toUpperCase() > b.userName.toUpperCase()) {
            return 1;
          } else if(a.userName.toUpperCase() < b.userName.toUpperCase())
          {
            return -1;
          }
        }
        return 0;
      });
    }
    if(filterType === 'TrinDocs')
    {
      filter.sort((a, b) => {
        if(a.licenseLevel > b.licenseLevel)
        {
          return -1;
        }
        else if(a.licenseLevel < b.licenseLevel)
        {
          return 1;
        } else {
          if (a.userName.toUpperCase() > b.userName.toUpperCase()) {
            return 1;
          } else if(a.userName.toUpperCase() < b.userName.toUpperCase())
          {
            return -1;
          }
        }
        return 0;
      });
    }
    if(filterType === 'All')
    {
      filter.sort((a, b) => {
        if (a.userName.toUpperCase() > b.userName.toUpperCase()) {
          return 1;
        } else if(a.userName.toUpperCase() < b.userName.toUpperCase())
        {
          return -1;
        }
        return 0;
      });
    }
    console.log(filter);
    return filter;
  }

  const changeUsersToShow = (e) => {
    console.log(e);

    let filter = sortUsers([...filteredUserList], e);

    updateFilteredUserList(filter);
    updateUsersToShow(e);
    console.log(filter);
  }


    let listOfUsers;
    if (userList !== null) {

      if (usersToShow === 'TrinForms'){
        listOfUsers = filteredUserList.map((user) => (
          <div
            key={user.userId}
            style={{
              display:
                (user.isActive || showInactive)
                &&
                (
                  (usersToShow === 'TrinForms' && user.trinFormsLicenseLevel > 0)
                )

                  ? 'block'
                  : 'none',
            }}
          >

          {user.trinFormsLicenseLevel >= 3 && user.isActive && (
            <i
                className='fa-solid fa-circle'
                style={{ fontSize: '9px', color: '#cd5c5c' }}
              />
            )}
            {user.trinFormsLicenseLevel === 2 && user.isActive && (
              <i
                className='fa-solid fa-circle'
                style={{ fontSize: '9px', color: '#5cc951' }}
              />
            )}
            {user.trinFormsLicenseLevel === 1 && user.isActive && (
              <i
                className='fa-solid fa-circle'
                style={{ fontSize: '9px', color: '#528ccd' }}
              />
            )}

            {user.trinFormsLicenseLevel === 3 && !user.isActive && (
              <i
                className='fa-regular fa-circle'
                style={{ fontSize: '9px', color: '#cd5c5c' }}
              />
            )}
           {user.trinFormsLicenseLevel === 2 && !user.isActive && (
              <i
                className='fa-regular fa-circle'
                style={{ fontSize: '9px', color: '#5cc951' }}
              />
            )}
            {user.trinFormsLicenseLevel === 1 && !user.isActive && (
              <i
                className='fa-regular fa-circle'
                style={{ fontSize: '9px', color: '#528ccd' }}
              />
            )}
            {' '}
            <Link
              className='sidebar-link'
              to={'/Admin/UsersView/' + user.userId}
              //onClick={() => this.handleBPClick(bp)}
              style={{ cursor: 'Pointer', wordWrap: 'break-word' }}
            >
              {user.userName}
            </Link>{' '}
            {user.trinFormsLicenseLevel === 5 && (
                <i
                className='fa-solid fa-lock'
                style={{ fontSize: '11px', color: '#888' }}
              />
            )}
          </div>
        ));
      }
      else if (usersToShow === 'TrinDocs'){
        listOfUsers = filteredUserList.map((user) =>
          ( user.licenseLevel > 0 && (user.isActive || showInactive) && <div
            key={user.userId}
          >
            {user.licenseLevel >= 4 && user.isActive && (
            <i role="userClass"
              className='fa-solid fa-circle'
              style={{ fontSize: '9px', color: '#cd5c5c' }}
              />
            )}
            {user.licenseLevel === 3 && user.isActive && (
              <i role="userClass"
                className='fa-solid fa-circle'
                style={{ fontSize: '9px', color: '#5cc951' }}
              />
            )}
            {user.licenseLevel === 2 && user.isActive && (
              <i role="userClass"
                className='fa-solid fa-circle'
                style={{ fontSize: '9px', color: '#528ccd' }}
              />
            )}
            {user.licenseLevel === 1 && user.isActive && (
              <i role="userClass"
                className='fa-solid fa-circle'
                style={{ fontSize: '9px', color: '#f1d951' }}
              />
            )}
            {user.licenseLevel === 4 && !user.isActive && (
              <i role="userClass"
                className='fa-regular fa-circle'
                style={{ fontSize: '9px', color: '#cd5c5c' }}
              />
            )}
             {user.licenseLevel === 3 && !user.isActive && (
              <i role="userClass"
                className='fa-regular fa-circle'
                style={{ fontSize: '9px', color: '#5cc951' }}
              />
            )}
            {user.licenseLevel === 2 && !user.isActive && (
              <i role="userClass"
                className='fa-regular fa-circle'
                style={{ fontSize: '9px', color: '#528ccd' }}
              />
            )}
            {user.licenseLevel === 1 && !user.isActive && (
            <i role="userClass"
              className='fa-regular fa-circle'
              style={{ fontSize: '9px', color: '#f1d951' }}
            />
            )}{' '}

            <Link
              className='sidebar-link'
              to={'/Admin/UsersView/' + user.userId}
              //onClick={() => this.handleBPClick(bp)}
              style={{ cursor: 'Pointer', wordWrap: 'break-word' }}
            >
              {user.userName}
            </Link>{' '}
            {user.licenseLevel === 5 && (
              <i
                className='fa-solid fa-lock'
                style={{ fontSize: '11px', color: '#888' }}
              />
            )}
          </div>
          )
        );
      }
      else{
        let listCopy = JSON.parse(JSON.stringify(filteredUserList));

        listCopy.sort((a,b) => (a.userName > b.userName) ? 1 : ((b.userName > a.userName) ? -1 : 0));

        listOfUsers = filteredUserList.map((user) => (
          <div
            key={user.userId}
            style={{
              display:
                licenseLevel === 5 || user.licenseLevel <= 4
                &&
                (user.isActive || showInactive)
                  ? 'block'
                  : 'none',
            }}
          >
            <Link
              className='sidebar-link'
              to={'/Admin/UsersView/' + user.userId}
              //onClick={() => this.handleBPClick(bp)}
              style={{ cursor: 'Pointer', wordWrap: 'break-word' }}
            >
              {user.userName}
            </Link>{' '}
            {user.licenseLevel === 5 && (
                 <i
                  className='fa-solid fa-lock'
                  style={{ fontSize: '11px', color: '#888' }}
                />
            )}
          </div>
        ));
      }
    } else {
      listOfUsers = <div />;
    }
    return (
      <div
        className='d-flex flex-column p-3 text-white bg-dark'
        style={{ height: '100%', width: '245px' }}
      >
        <Link
          to='/v/administration/directories'
          className='d-flex align-items-center mb-3 mb-md-0 me-md-auto text-white text-decoration-none'
        >
          <span className='fs-4'>
            <i className='fa-solid fa-user' />
            {'   '}
            Users
          </span>
        </Link>
        <hr />
        <div className='input-group rounded' style={{ marginBottom: '16px' }}>
          <input
            type='search'
            value={searchText}
            className='form-control'
            placeholder='Search'
            aria-label='Search'
            onChange={onSearchChange}
            aria-describedby='search-addon'
          />
          <span className='input-group-text border-0' id='search-addon'>
            <i className='fa-solid fa-search' />
          </span>
        </div>

        <Link className='sidebar-link' to='/Admin/UsersView/0'>
          New User
        </Link>
        <hr />

        <div className='justify-content-center mb-1'>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='usersToShow'
              id='TrinDocs'
              onChange={() => changeUsersToShow('TrinDocs')}
              checked={usersToShow === 'TrinDocs'}
            />
            <label className='form-check-label'>TrinDocs</label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='usersToShow'
              id='TrinForms'
              onChange={() => changeUsersToShow('TrinForms')}
              checked={usersToShow === 'TrinForms'}
            />
            <label className='form-check-label'>TrinForms</label>
          </div>
          <div className='form-check form-check-inline'>
            <input
              className='form-check-input'
              type='radio'
              name='usersToShow'
              id='All'
              onChange={() => changeUsersToShow('All')}
              checked={usersToShow === 'All'}
            />
            <label className='form-check-label'>All</label>
          </div>
        </div>
        <div className='form-check form-switch'>
          <input
            type='checkbox'
            role='inactiveSwitch'
            className='form-check-input'
            checked={showInactive}
            onChange={changeShowInactive}
            id='chkActive'
          />
          <label
            className='form-check-label'
            style={{ fontSize: '8pt' }}
            htmlFor='chkActive'
          >
            Show Inactive
          </label>
        </div>
        <div
          className='coolScroll'
          style={{ maxHeight: screenHeight - 355, overflowY: 'scroll' }}
        >
          {listOfUsers}
        </div>

      </div>
    );
}

export default UsersSidebar;
